(ns web3.screens.model
  (:require-macros [web3.build.assets :as assets])
  (:require [reagent.core :as r]
            [web3.routing.core :as routing]
            [web3.components.widgets :as widgets]
            [web3.i18n :as i]
            [web3.components.legal :as legal]
            [web3.persistence.schema :as schema]
            [web3.modals.alerts :as alerts]
            [web3.components.card :as card]
            [web3.components.icons :as icons]
            [web3.screens.content :as content]
            [web3.utils :as utils]
            [web3.view :as v]
            [web3.constants :as constants]
            [clojure.string :as str]
            [web3.backend-stubs :as backend-stubs]
            [web3.auth.lazy-api :as lazy-auth]
            [web3.queries.asset :as q-asset]
            [web3.ui-state :as ui-state]
            [web3.components.badge :as badge]
            [web3.hints.core :as hints]
            [web3.env :as env]
            [web3.routers.app-helpers :as app-route]
            [web3.screens.asset :as asset]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]
            [web3.icons.asset :as asset-i]
            [web3.meta.asset :as asset-meta]
            [shadow.lazy :as lazy]
            [web3.log :as log]
            [web3.components.linkify :as linkify]
            [web3.components.text :as text]))

(def intercom-show! (lazy/loadable web3.components.intercom/show!))

(defn asset-card-props
  [{:keys [manufacturer alertStatus primaryImage thumbnailImage id editable? recalls edit?] :as asset
    :or {editable? true}}]
  (let [props {:key id
               :label (schema/asset-display-name asset)
               :sub-label manufacturer
               :media-divider? true}
        icon (when-not primaryImage
               (some-> (backend-stubs/asset-tag->icon-name (get-in asset [:tag :id]))
                       (icons/get)))]
    (merge
      props
      (if (and editable? edit?)
        {:on-delete (partial asset/delete-asset asset)}
        {:href (app-route/details-href asset)})
      (cond (= alertStatus
               "processing") {:icon [asset/alert-status-processing-icon]}
            icon {:icon icon}
            :else {:image (:link (or thumbnailImage primaryImage))})
      (when-let [badge (case alertStatus
                         "processing" nil
                         "errored" (asset/alert-status-badge :errored)
                         (when recalls
                           (asset/alert-status-badge :recalled)))]
        {:badge [:div.round-100p.inline-block.bg-white.line-h-8
                 badge]}))))

(v/defview model-header
  {:component-did-mount (fn [this]
                          (when-not (ui-state/mobile?)
                            (hints/activate-hint-mode!)))}
  [{:as entity
    {image-source :link} :primaryImage}]
  (log/sym entity)
  (let [edit? false
        field-header :div.text-uppercase.text-dark-gray.text-size-10
        field-value :div.text-uppercase.text-black.text-size-13
        field-value-link :a.text-uppercase.text-blue.text-size-13
        tagName (-> entity :tags first :name)
        manufacturer (-> entity :manufacturer :name)
        modelNumber (-> entity :number)
        compat-entity {:tagName tagName
                       :manufacturer manufacturer
                       :modelNumber modelNumber}]

    [:header.flex.flex-column.pre-wrap.bg-white
     [:div.flex.items-stretch.flex-column-mobile.pad-h-2.margin-top-2
      [:div.modal-header-image.flex-none.margin-all-2.flex.justify-center
       (cond image-source {:style {:background-image (str "url(" image-source ")")
                                   :height (when image-source 250)
                                   :flex "1 1 auto"}})
       (when (not image-source)
         (some-> (backend-stubs/asset-tag->icon-name (get-in entity [:tag :id]))
                 (icons/get)
                 (hiccup/styles {:height 100
                                 :margin-top 30})))]

      [:div.flex.width-100p.flex-wrap
       {:style {:flex "1 3 auto"}}
       [:div.flex.flex-column.margin-h-2.margin-top-2.overflow-hidden.flex-auto
        {:style {:flex "1 0 auto"
                 :max-width "fit-content"}}
        [:div.flex.items-start.flex-wrap
         [:div.text-size-26.weight-semi-bold.flex.items-center.flex-auto.pad-bottom-2
          (schema/model-display-name entity)]]

        (when (lazy-auth/call-if-loaded :logged-in?)
          (when-let [find-a-pro-link (schema/model-find-a-pro entity)]
            [widgets/black-button {:href find-a-pro-link
                                   :class "inline-flex"
                                   :style {:margin-right 30}
                                   :target "_blank"
                                   :rel "noopener"} (i/get :drawer/need-help.label)]))
        (doall (for [key [:Asset/tagName
                          :Asset/manufacturer
                          :Asset/modelNumber]
                     :let [value (get compat-entity (utils/simplify-keyword key))]
                     :when (or edit? value)]
                 [:div.margin-v-2.line-h-18
                  {:key (str key "-readonly")}
                  [field-header
                   (i/get (if (= key :Asset/tagName)
                            ;; Asset/tagName is called "type" in read-only mode
                            :i/type
                            key))]
                  [field-value
                   value]]))
        (when-not edit?
          (when-let [{:keys [manufacturerSupportPhone
                             manufacturerSupportWebsite]} entity]
            (log/sym manufacturerSupportPhone)
            (log/sym manufacturerSupportWebsite)
            [:div
             (when manufacturerSupportPhone [:div.margin-v-2.line-h-18
                                             [field-header (i/to-do "Support")]
                                             [field-value-link
                                              {:href (str "tel:" manufacturerSupportPhone)}
                                              manufacturerSupportPhone]])

             (when manufacturerSupportWebsite [:div.margin-v-2.line-h-18
                                               [field-header (i/to-do "Website")]
                                               [field-value
                                                [linkify/linkify (utils/strip-www manufacturerSupportWebsite)]]])]))]
       (when-not (lazy-auth/call-if-loaded :logged-in?)
         [:div.flex.flex-auto
          {:style {:flex "1 0 250px"}}
          [:div.flex.flex-column.height-100p.justify-end.pad-all-2
           {:style {:margin-left :auto
                    :min-width "250px"
                    :max-width "100%" #_"330px"}}


           (when (lazy/ready? intercom-show!)
             [widgets/black-button {:on-click #(@intercom-show!)
                                    :class "width-100p"
                                    :style {:margin-bottom "auto"}}

              (i/to-do "Get Help")])
           [:div.text-size-26.weight-semi-bold.margin-v-2
            (let [asset (-> entity :tags first :name)]
              (i/get :model/is-this-your {:asset asset}))]
           [:div.margin-top-3 (i/to-do (str "Create a free account to keep it handy,"
                                            " along with everything else you own."))]
           #_[widgets/black-button {:class "width-100p margin-v-2"} "Add to Centriq"]
           [:div.text-blue.pad-v-2.flex
            (i/to-do (str "What is " (:partner/name env/config) "?"))
            [:div.pad-h-2
             {:on-mouse-enter #(hints/show! [:hints/public.what-is-centriq])}
             [:div#what-is-centriq-i
              [badge/badge
               {:style {:background-color (:blue constants/colors)}
                :class "text-white weight-bold"}
               "i"]]]]]])]]]))

(defn model-alert-status [{:keys [recalls
                                  tags
                                  tagName]}]
  (when-let [{:keys [bg-color
                     color
                     icon
                     title
                     detail
                     action]
              :or {color "black"}}
             (when (seq recalls)
               (let [tag (first tags)
                     tag-name (or tagName
                                  (some-> (:name tag)
                                          (str/lower-case)))]
                 {:bg-color "rgb(32, 38, 45"
                  :color "white"
                  :icon (-> asset-i/badge-exclamation
                            (hiccup/styles {:color (:red constants/colors)}))
                  :title (i/get :asset/alert-status.recalled.title {:tagName tag-name})
                  :detail (:title (first recalls))
                  :action [:div.flex
                           [widgets/primary-button {:href (:url (first recalls))
                                                    :target "_blank"
                                                    :rel "noopener"
                                                    :class "bg-white text-black hover-bg-off-white margin-right-2"}
                            (i/get :i/take-action)]]}))]

    [:div.pad-h-3
     [:div.pad-v-3.pad-h-3.flex.items-start.flex-column-mobile.round-7
      {:style {:background-color bg-color
               :color color}}
      [:div.margin-all-2.flex-auto.flex
       [:div.margin-right-2 (hiccup/size icon 32)]
       [:div
        [:div.text-size-26.weight-semi-bold.margin-bottom-2
         title]
        [:div.text-size-16.line-h-20
         {:style {:max-width 600}}
         detail]]]
      [:div.margin-all-2.flex.items-end.text-align-right action]]]))

(v/defview collapsible-curated-grid
  [entity {:keys [label cards not-found-key not-found-label]}]
  (let [{:keys [state]} (r/current-component)
        {:keys [collapsed?]} @state]
    [:div
     [asset/section-title
      {:key label
       :class "cursor-pointer hover-opacity-parent"
       :on-click #(swap! state update :collapsed? not)}
      [:div.inline-block.pad-left-2.pad-right-3
       (-> (if collapsed?
             shapes/chevron-down
             shapes/chevron-up)
           (hiccup/class "hover-opacity-child"))]
      label
      (utils/coll-count 20 cards)]
     (when-not collapsed?
       [card/card-grid
        (assoc card/curated-grid-props
          :key (str label "-grid")
          :class "margin-bottom-3")
        (cond-> (vec cards)
          (empty? cards)
          [{:key "not-found"
            :icon (icons/get not-found-key)
            :card-style :dashed-gray
            :class "opacity-60"
            :label (i/get not-found-key)}]

          (lazy/ready? intercom-show!)
          (conj {:key "not-found/ask"
                 :wrap? true
                 :media-height "100%"
                 :on-click #(let [manufacturer (get-in entity [:manufacturer :name])
                                  model-number (:number entity)]
                              (@intercom-show! (i/get (keyword (namespace not-found-key)
                                                               (str (name not-found-key) ".inquiry"))
                                                      (merge {:partnerName (:partner/name env/config)
                                                              :domain utils/domain
                                                              :missingType (if not-found-label
                                                                             not-found-label
                                                                             label)
                                                              :modelNumber model-number
                                                              :manufacturer manufacturer}))))

                 :media [:div.text-size-14.pad-all-2
                         (i/get :not-found/ask)
                         [:div.margin-top-2 asset/mail-icon]]}))])]))

(defn- entity->model-display-str
  [{:keys [number manufacturer]}]
  (let [model-number number
        manufacturer-name (:name manufacturer)]
    (str manufacturer-name " " model-number)))

(v/defview search-bar
  {:component-did-mount
   (fn [{:keys [state argv]}]
     (when-let [entity (second argv)]
      (swap! state assoc :input (entity->model-display-str entity))))}
  [entity]
  (let [{:keys [state]} (r/current-component)]
   [:form {:method "get" :title "Search Form" :action "https://cse.google.com/cse/publicurl"}
    [:div.pad-all-4
     [:div.pad-h-4.flex
      [:div.text-dark-gray.text-size-30.pad-bottom-3.pad-h-2
       {:style {:padding-top "13px"}}
       "Get help with your"]
      [text/input {:id "q" :name "q" :title "Search this site"
                   :alt "Search Text" :maxlength "256"
                   :suggested-value (entity->model-display-str entity)
                   :value (:input @state)
                   :content/inline-right (icons/get "magnifying-glass")
                   :on-change #(swap! state assoc :input (.. % -target -value))
                   :mdc-container {:style {:font-size "30px"}}}]]
     [:input#cx {:type "hidden" :name "cx" :value "011526079571446734764:ydw0uvmx18o"}]]]))

(v/defview model-page
  [{:as entity
    curated-contents :contents
    products :products}
   grid-opts]
  (let [{encompass-count :productCount
         encompass-link :modelPageLink} (:encompassData entity)
        {not-found-products :config/not-found-products
         not-found-videos :config/not-found-videos
         not-found-manuals :config/not-found-manuals} grid-opts
        {how-to true
         manuals false} (->> curated-contents
                             (filter (comp #{"document" "note" "video"} :category))
                             (group-by (comp (partial = "video") :category)))]
    [:div.flex.flex-column.pre-wrap
     [search-bar entity]
     [model-alert-status entity]
     [model-header entity]
     [:div.modal-divider]
     (into [:main.bg-off-white.pad-h-2]
           (->> [{:label (i/get :asset/products)
                  :cards (concat
                          (for [{:as product
                                 :keys [primaryImage thumbnailImage uuid]
                                 label :name} products]
                            (merge product
                                   {:key uuid
                                    :json-ld (asset-meta/product-SD product
                                                                    {:sd/accessory-or-part-for-url
                                                                     (asset-meta/current-url)})
                                    :label label
                                    :label-lines 2
                                    :label-size 13
                                    :media-divider? true
                                    :expand-when legal/request-response
                                    :expanded-view content/product-details}
                                   (if-let [image (:link (or thumbnailImage primaryImage))]
                                     {:image image}
                                     {:icon asset-i/product})))
                          (when (and (pos? encompass-count)
                                     encompass-link
                                     constants/encompass-service-is-enabled?)
                            [{:label (i/to-do (str "View all " encompass-count " items"))
                              :image (assets/with-hash "/images/card-encompass-rectangle@3x.png")
                              :link encompass-link
                              :href encompass-link
                              :large? true
                              :curated true
                              :media-divider? true
                              :label-inverted true
                              :image-fit "cover"
                              :mediaType "text/html"
                              :icon asset-i/product}]))
                  :not-found-key (or not-found-products :not-found/products)}

                 ;; Manuals & Guides
                 {:label (i/get :files/manuals)
                  :cards (->> manuals
                              (mapv #(content/content-card (assoc % :large? true
                                                                    :href (:link %)
                                                                    :expanded-view content/content-details))))
                  :not-found-key (or not-found-manuals :not-found/manuals)
                  :not-found-label "documents"}

                 {:label (i/get :content/how-tos)
                  :cards (->> how-to
                              (mapv #(content/content-card (assoc % :large? true
                                                                    :expanded-view content/content-details))))
                  :not-found-key (or not-found-videos :not-found/videos)
                  :not-found-label "videos"}]

                (filter (comp seq :cards))
                (mapv (fn [x] [collapsible-curated-grid entity x]))
                (interpose asset/divider)))]))


